import classes from './MealsSummary.module.css';

const MealsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Delicious Food, Delivered To You</h2>
      <p>
        Choose your favorite meal from our broad selection of available meals
        and enjoy a delicious lunch or dinner at home.
      </p>
      <p>
      Krowarzywa are vegan burgers stuffed to the brim with fresh, wholesome, vegetable ingredients. We prepare them with passion and they are huge. It’s the taste, you will not forget
      </p>
    </section>
  );
};

export default MealsSummary;